/* WISAMIN · company profile video — facade embed, no third-party JS until click */
(function () {
  'use strict';

  function swap(btn) {
    var id = (btn.getAttribute('data-id') || '').trim();
    if (!id) return;
    var start = parseInt(btn.getAttribute('data-start'), 10) || 0;

    var src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
      '?autoplay=1&rel=0&modestbranding=1&playsinline=1' +
      (start > 0 ? '&start=' + start : '');

    var frame = document.createElement('iframe');
    frame.className = 'pv__if';
    frame.src = src;
    frame.title = btn.getAttribute('aria-label') || 'Video';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('loading', 'lazy');

    var host = btn.parentNode;
    if (!host) return;
    host.replaceChild(frame, btn);
    try { frame.focus(); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-pv-play]') : null;
    if (!btn) return;
    e.preventDefault();
    swap(btn);
  });

  /* Warm the DNS/TLS handshake on first intent, so the click feels instant. */
  var warmed = false;
  function warm() {
    if (warmed) return;
    warmed = true;
    ['https://www.youtube-nocookie.com', 'https://i.ytimg.com'].forEach(function (h) {
      var l = document.createElement('link');
      l.rel = 'preconnect';
      l.href = h;
      l.crossOrigin = '';
      document.head.appendChild(l);
    });
  }
  document.addEventListener('pointerover', function (e) {
    if (e.target.closest && e.target.closest('[data-pv-play]')) warm();
  }, { passive: true });
  document.addEventListener('focusin', function (e) {
    if (e.target.closest && e.target.closest('[data-pv-play]')) warm();
  });
})();
